module.exports = __webpack_public_path__ + "img/nim_logo.a74048de.png";